import { render, staticRenderFns } from "./behaviour_modal.vue?vue&type=template&id=37fc3788&"
import script from "./behaviour_modal.vue?vue&type=script&lang=js&"
export * from "./behaviour_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports